import * as React from "react";
import * as ReactDOM from "react-dom";
import Commonnav from "@/layouts/commonnav/commonnav";
import ZeusDocumentSupportBanner from "@/widgets/zeus_document_support_banner";
import ZeusDocumentSupportBannerData from "./data/zeus_document_support_banner/data";

import ZeusApiList from "@/widgets/zeus_api_list";
import ZeusApiListData from "./data/zeus_api_list/data";

import ZeusHomepageFloatRightbar1817 from "@/widgets/zeus_homepage_float_rightbar1817";
import ZeusHomepageFloatRightbar1817Data from "./data/zeus_homepage_float_rightbar1817/data";

class Home extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <Commonnav>
        <div className="jdw-container">
          <div className="jdw-row">
            <div className="jdw-column">
              <div className="jdw-widget" data-name="zeus_document_support_banner" data-version="8.0.2">
                <ZeusDocumentSupportBanner {...ZeusDocumentSupportBannerData} />
              </div>

              <div className="jdw-widget" data-name="zeus_api_list" data-version="20.1.3">
                <ZeusApiList {...ZeusApiListData} />
              </div>
            </div>
          </div>
        </div>

        <div className="jdw-container">
          <div className="jdw-row">
            <div className="jdw-column">
              <div className="jdw-widget" data-name="zeus_homepage_float_rightbar" data-version="1.2.1">
                <ZeusHomepageFloatRightbar1817 {...ZeusHomepageFloatRightbar1817Data} />
              </div>
            </div>
          </div>
        </div>
      </Commonnav>
    );
  }
}

ReactDOM.render(<Home />, document.getElementById("root"));
